/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * Schema for a DIDComm message attachment descriptor used in batch creation. It contains metadata about the attachment including its size and media type.
 */
export interface DidCommMessageBlobAttachmentDescriptor {
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    downloadUri: string;
    filename?: string;
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    id: string;
    mediaType: string;
    size: number;
}
